export const DESCRIPTION_ID_PREFIX = 'syf-help-text';
//# sourceMappingURL=constants.js.map